'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _attendeeInfo = require('../actions/attendee-info');

var Actions = _interopRequireWildcard(_attendeeInfo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { webinarAttendeeInfo: {} };
    var action = arguments[1];

    switch (action.type) {

        case Actions.SET_WEBINAR_ATTENDEE_INFO_COMPLETE:
            {
                var attendeeInfo = Object.assign({}, state.attendeeInfo);
                attendeeInfo.webinarAttendeeInfo = action.webinarAttendeeInfo;
                return _extends({}, state, {
                    webinarAttendeeInfo: action.webinarAttendeeInfo
                });
            }

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/attendee-info.js
// module id = 790
// module chunks = 0